import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_EncounterData, } from '@app/ehr-emulator-shared';
export const dispatch_onEncounterDataChanged = new ThunderDispatcherV3('__onEncounterDataUpdated');
export class ModuleFE_EncounterData_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_EncounterData, dispatch_onEncounterDataChanged);
        this._v1 = {};
    }
}
export const ModuleFE_EncounterData = new ModuleFE_EncounterData_Class();
//# sourceMappingURL=ModuleFE_EncounterData.js.map